import React ,{ Component }from "react";
import { FiLayers , FiUsers , FiMonitor } from "react-icons/fi";
import { FaShoppingCart } from "react-icons/fa";

const ServiceList = [
    {
        icon: <FaShoppingCart />,
        title: 'E-Commerce',
        description: 'Porta il tuo business al successo creando un negozio online funzionale, sicuro e semplice'
    },
    {
        icon: <FiLayers />,
        title: 'Gestionali, CRM',
        description: 'Crea un\'applicazione che si adatta alle tue esigenze, per gestire al meglio e semplificare i processi interni.'
    },
    {
        icon: <FiUsers />,
        title: 'Siti web',
        description: 'Sito web di qualità , realizzato con soluzioni professionali analizzate e studiate su misura per la tua attività'
    },
 
]


class ServiceThree extends Component{
    render(){
        const {column } = this.props;
        const ServiceContent = ServiceList.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row service-main-wrapper">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            <a href="/service-details">
                                <div className="service service__style--2 text-left bg-gray">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
